const type = 'SET_PAYMENT_EMAIL_SENT';

const setPaymentEmailSent = () => ({
  type,
});

export default setPaymentEmailSent;
